<div class="w-100 min-vh-100 bg-white-100 container-fluid" style="background-color: white; padding-bottom: 15px">
  <div class="mt-2 pt-5 mx-md-4">
    <header><h3>Reports</h3></header>

    <div class="btn-group shadow-lg d-flex flex-wrap flex-grow-1 flex-md-grow-0 mb-3">
      <button type="button" class="btn btn-custom" [ngClass]="{ 'active': activeSection === 'standard' }" (click)="setActive('standard')">
        <span class="material-symbols-outlined">table_chart</span> Standard Reports
      </button>
      <button type="button" class="btn btn-custom" [ngClass]="{ 'active': activeSection === 'custom' }" (click)="setActive('custom')">
        <span class="material-symbols-outlined">tune</span> Create Custom Report
      </button>
      <button type="button" class="btn btn-custom" [ngClass]="{ 'active': activeSection === 'generate' }" (click)="setActive('generate')">
        <span class="material-symbols-outlined">docs</span> Generate Standard School Form
      </button>
    </div>

    <h6 *ngIf="activeSection === 'generate'" class="mt-4 text-muted">Generate standard format reports for <b>Food Waste Audits</b></h6>
    <h6 *ngIf="activeSection === 'standard'" class="mt-4 text-muted">Export data by cluster or all school totals in Excel compatible format</h6>
    <h6 *ngIf="activeSection === 'custom'" class="mt-4 text-muted">Advanced search and export options for annual school profiles, projects, and partners</h6>

    <div class="mt-4 shadow-lg" id="sections">
      <app-generate-form *ngIf="activeSection === 'generate'"></app-generate-form>
      <app-standard-form *ngIf="activeSection === 'standard'"></app-standard-form>
      <app-custom-form *ngIf="activeSection === 'custom'"></app-custom-form>
    </div>
  </div>
</div>
